module.exports = __webpack_public_path__ + "img/Weapon_17.cb55f275.png";